import React, { FC, Fragment, memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { IconFontLayer } from "../../../../../../icon-font/iconfont-layer";
import { selectCandidateProfile } from "../../../../../auth/redux/selector";
import { convertAssessments } from "./prudna-widget.util";

type ComponentProps = {
  /* otherProp */
  assessment: any;
};

export const PrudnaWidgetComponent: React.FC<ComponentProps> = memo(
  ({ assessment }: ComponentProps) => {
    // i18n
    const { t } = useTranslation();
    const candidateProfile = useSelector(selectCandidateProfile);
    const { title, message, time, leftConfig, rightConfig, buttons, iconName } = convertAssessments(
      {
        assessment,
        isCandidateActive: candidateProfile?.status === "IN_PROGRESS",
      },
    );

    const hasLeftConfig = useMemo(() => leftConfig && leftConfig?.length > 0, [leftConfig]);
    const hasRightConfig = useMemo(() => rightConfig && rightConfig?.length > 0, [rightConfig]);

    return (
      <div className="bg-white px-4 py-4 flex flex-col w-full">
        <span className="text-base font-medium mb-1">{title}</span>
        <span className="text-xs font-medium text-[#999]">{time}</span>
        {message ? (
          <Fragment>
            {iconName && (
              <IconFontLayer
                size={28}
                backgroundSize={52}
                containerStyle={{
                  borderRadius: 26,
                  borderWidth: 0,
                  backgroundColor: "#FFEFE3",
                  marginTop: 16,
                  alignSelf: "center",
                }}
                color="#FF872E"
                name={iconName}
              />
            )}
            <span className="text-sm font-medium text-[#858585] text-center mt-4">{message}</span>
          </Fragment>
        ) : (
          <div className="flex flex-row flex-1 mt-5">
            <ConfigList title={t("Recruitment.your_strengths")} type="left" items={leftConfig} />
            {hasLeftConfig && hasRightConfig && (
              <div className="w-[2px] bg-[#E6E6E6] h-auto mx-3 " />
            )}
            <ConfigList
              title={t("Recruitment.your_areas_for_growth")}
              type="right"
              items={rightConfig}
            />
            {(!hasLeftConfig || !hasRightConfig) && <div className="flex-1 ml-6" />}
          </div>
        )}

        {buttons?.map((button, index) => (
          <button
            key={index}
            className="w-[183px] self-center flex items-center justify-center py-2 px-4 border-[2px] rounded-lg border-[#CCC] mt-4"
            onClick={() => button.onPress?.()}
          >
            <span className="text-sm font-medium">{t(button.text)}</span>
          </button>
        ))}
      </div>
    );
  },
);

export  const ConfigList: FC<{ /* PHKL custom */
  title: string;
  type: "left" | "right";
  items?: any[];
}> = ({ title, type, items }) => {
  if (!items?.length) return null;

  return (
    <div className="flex flex-col flex-1">
      <span className="text-sm font-medium">{title}</span>
      <ul
        className={`${
          type === "left" ? "bg-[#DFF7EF]" : "bg-[#FFEFE3]"
        } mt-2 list-disc pl-5 py-2 flex flex-col gap-[6px] rounded flex-1`}
      >
        {items.map((config) => (
          <li
            key={config.label}
            className={`text-[11px] font-medium ${
              type === "left" ? "text-[#24C791]" : "text-[#FF872E]"
            }`}
          >
            {config.label}
          </li>
        ))}
      </ul>
    </div>
  );
};
